import { InMemoryOriginsRepository } from "../../../../../test/repositories/inMemoryOriginsRepository"
import { ICreateOriginProtocol } from "../../protocols/origin/ICreateOriginProtocol"
import { CreateOriginUseCase } from "./createOrigin"
import { makeOrigin } from "../../../../../test/factories/makeOrigin"
import { OriginStatus } from "@/domain/entities/Origin"

let sut: ICreateOriginProtocol
let repository: InMemoryOriginsRepository

describe('Create Origin', () => {
  beforeEach(() => {
    repository = new InMemoryOriginsRepository()
    sut = new CreateOriginUseCase(repository)
  })
  it('Should be able to create a new origin', async () => {
    const { origin } = await sut.execute({
      name: 'Test Origin'
    })

    expect(repository.items.length).toEqual(1)
    expect(origin).toEqual(repository.items[0])
  })

  it('Should be able to create a new origin with status disabled', async () => {
    const { origin } = await sut.execute({
      name: 'Test Origin',
      status: OriginStatus.DISABLED
    })

    expect(repository.items.length).toEqual(1)
    expect(repository.items[0].status).toEqual(OriginStatus.DISABLED)
    expect(origin).toEqual(repository.items[0])
  })

  it('Should not be able to create a new origin with same name', async () => {
    const originOnDatabase = makeOrigin({
       name: 'Test Origin'
    })
    await repository.create(originOnDatabase)

    expect(() => {
      return sut.execute({
        name: 'Test Origin'
      })
    }).rejects.toBeInstanceOf(Error)
  })
})